<nav class="navigation-header-container">
  <a mat-stroked-button
     routerLink="/kontakter"
     routerLinkActive="active">Kontakter</a>
  <a mat-stroked-button
     routerLinkActive="active"
     routerLink="/kategorier">Kategorier</a>
</nav>
